export default __webpack_public_path__ + "static/media/retreiveOnePIC2.804a4650.jfif";